import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  List,
  ListItem,
  Box,
  Button,
  Alert,
  Chip,
  Divider,
  Paper,
  Grid,
  Card,
  CircularProgress,
  LinearProgress,
  TextField,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { fireEmojiStars } from './starBurst'; // Adjust path if in same file

import PeopleIcon from '@mui/icons-material/People';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import DescriptionIcon from '@mui/icons-material/Description';
import FlagIcon from '@mui/icons-material/Flag';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import VerifiedIcon from '@mui/icons-material/Verified';
import ParallaxBackground from './ParallaxBackground'; // adjust path
import Navbar from './Navbar';
import AdvertCards from './AdvertCards';
import ChatWidget from './Chatbot';
import LeftNavbar from './LeftNav';

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SchoolIcon from '@mui/icons-material/School';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TrendingDivider from './TrendingDivider';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

function DashboardPage() {
  const [user, setUser] = useState(null);
  const [allCourses, setAllCourses] = useState([]);
  const [error, setError] = useState('');
  const [viewedChaptersMap, setViewedChaptersMap] = useState({});
  const [chapterCounts, setChapterCounts] = useState({});
  const token = localStorage.getItem('token');
  const navigate = useNavigate();
  const [isLocked, setIsLocked] = useState(true);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [offsetY, setOffsetY] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20; // Adjust multiplier for effect strength
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setOffset({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  

  useEffect(() => {
    const handleScroll = () => {
      setOffsetY(window.scrollY * 0.5); // Adjust multiplier for more/less effect
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const backgroundStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '60%',
    backgroundImage: 'url("6.png")',
    backgroundRepeat: 'repeat',
    backgroundSize: 'cover',
    backgroundPosition: `center ${-offsetY}px`,
    backgroundAttachment: 'fixed',
    zIndex: 0,
    pointerEvents: 'none',
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsLocked(prev => !prev);
    }, 2000); // 2 seconds loop
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!token) return;

    fetch('http://196.216.9.34:5020/api/users/me', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => (data.message ? setError(data.message) : setUser(data)))
      .catch(() => setError('Failed to load user data'));

    fetch('http://196.216.9.34:5020/api/courses', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(setAllCourses)
      .catch(() => setError('Failed to load courses'));
  }, [token]);

  // Fetch viewedChapters and chapterCount per course
  useEffect(() => {
    if (!user || user.role !== 'student') return;

    const fetchProgressData = async () => {
      const viewed = {};
      const counts = {};

      await Promise.all(
        user.enrolledCourses.map(async (course) => {
          try {
            const resViewed = await fetch(`http://196.216.9.34:5020/api/courses/${course.id}/viewed-chapters`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            const dataViewed = await resViewed.json();
            viewed[course.id] = dataViewed.viewedChapters || [];

            const resCount = await fetch(`http://196.216.9.34:5020/api/courses/${course.id}/chapter-count`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            const dataCount = await resCount.json();
            counts[course.id] = dataCount.chapterCount || 0;
          } catch (err) {
            console.error('Progress fetch error for course:', course.id, err);
          }
        })
      );

      setViewedChaptersMap(viewed);
      setChapterCounts(counts);
    };

    fetchProgressData();
  }, [user, token]);

  const handleDeleteCourse = async (courseId) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this course?');
  
    if (!confirmDelete) return;
  
    try {
      const response = await fetch(`http://196.216.9.34:5021/api/courses/${courseId}`, {
        method: 'DELETE',
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        alert(data.message || 'Failed to delete course');
        return;
      }
  
      // Remove course from local state
      setUser((prev) => ({
        ...prev,
        teachingCourses: prev.teachingCourses.filter((course) => course.id !== courseId),
      }));
    } catch (error) {
      console.error('Error deleting course:', error);
      alert('An error occurred while deleting the course.');
    }
  };
  
  

  const enroll = (courseId) => {

    // Redirect to PaymentRegister page with course + user details
    navigate("/payment-register", {
      state: {
        courseId,
      },
    });


    // fetch(`http://196.216.9.34:5020/api/courses/${courseId}/enroll`, {
    //   method: 'POST',
    //   headers: { Authorization: `Bearer ${token}` },
    // })
    //   .then(async res => {
    //     const data = await res.json();
    //     if (res.ok) {
    //       alert(data.message || 'Enrolled successfully');
    //       return fetch('http://196.216.9.34:5020/api/users/me', {
    //         headers: { Authorization: `Bearer ${token}` },
    //       })
    //         .then(res => res.json())
    //         .then(setUser);
    //     } else {
    //       alert(data.message || 'Error enrolling');
    //     }
    //   })
    //   .catch(() => alert('Network error while enrolling'));
  };

  if (error) return <Alert severity="error" sx={{ m: 4 }}>{error}</Alert>;
  if (!user) return <Box textAlign="center" mt={8}><CircularProgress /><Typography mt={2}>Loading...</Typography></Box>;

  return (
    
    <Box sx={{ display: 'flex', position: 'relative', minHeight: '100vh'}}>
      
      <Box
      style={backgroundStyle}
     
      
    />
    <LeftNavbar />
    <Box component="main" sx={{ flex: 1, ml: { lg: '250px' }, position: 'relative', zIndex: 1 }}>
      <Container maxWidth="md" sx={{ py: 5 }}>
        
        <Navbar />
        
        <ChatWidget apiEndpoint="http://192.168.24.123:5023/chat" 
          user={user}
          allCourses={allCourses}
          viewedChaptersMap={viewedChaptersMap}
          chapterCounts={chapterCounts} title="Course Assistant" 
        />
    
        <Box textAlign="center" mb={4} mt={4}>
          <Typography style={{ color: 'white' }} variant="h4" fontWeight="bold" gutterBottom>
            Welcome, {user.username}!
          </Typography>
         
        </Box>

        {user.role === 'student' && (
          <>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 32,
                  height: 32,
                  transition: 'transform 0.3s ease, opacity 0.3s',
                  transform: isLocked ? 'scale(1)' : 'scale(1.3)',
                }}
              >
                {isLocked ? (
                  <Box
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    padding: 1,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  key="locked"
                >
                  <LockIcon color="black" />
                </Box>
                ) : (
                  <Box
              sx={{
                backgroundColor: 'white',
                borderRadius: '50%',
                padding: 1,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '5px'
              }}
              key="unlocked"
            >
              <LockOpenIcon color="warning" />
            </Box>
                )}
              </Box>
              <Typography style={{ color: 'white' }} variant="h7" ml={3} fontWeight="bold" gutterBottom>
                Your Enrolled Courses
              </Typography>
            </Box>

            {user.enrolledCourses.length === 0 ? (
              <Typography color="white">You are not enrolled in any courses yet.</Typography>
            ) : (
              <Grid container spacing={3} sx={{ mb: 4 }}>
                {user.enrolledCourses.map(course => {
                  const viewed = viewedChaptersMap[course.id] || [];
                  const total = chapterCounts[course.id] || 0;
                  const percent = total ? Math.round((viewed.length / total) * 100) : 0;

                  return (
                    <Grid item xs={12} md={6} lg={4} key={course.id} className="w3-animate-zoom">
                      <Paper
                      className="w3-animate-zoom"
                        elevation={6}
                        sx={{
                          p: 3,
                          height: '100%',
                          display: 'flex',
                          borderRadius: 4,
                          background: 'rgba(255, 255, 255, 0.85)',
                          backdropFilter: 'blur(10px)',
                          boxShadow: '0 8px 32px rgba(0,0,0,0.1)', 
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          borderTop: '3px solid #ff6600',
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 6,
                            cursor: 'pointer',
                          },
                        }}
                        onClick={() => navigate(`/courses/${course.id}/chapters`)}
                      >
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="h6" fontWeight="bold" gutterBottom>
                            {course.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {course.description}
                          </Typography>
                        </Box>

                        {total > 0 && (
                          <Box mb={2}>
                            <Typography variant="body2" fontWeight="bold" mb={0.5}>
                              Progress: {viewed.length} of {total} chapters ({percent}%)
                            </Typography>
                            <LinearProgress variant="determinate" value={percent} />
                          </Box>
                        )}

                        <Button
                          variant="contained"
                          size="small"
                          style={{background: "rgba(0,0,0,0.7)"}}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/courses/${course.id}/chapters`, { state: { user } });
                          }}
                        >
                          Open Course
                        </Button>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            )}

            <TrendingDivider />
            <AdvertCards />
            <Divider sx={{ my: 4 }} />
            

            <>
  <Typography style={{ color: 'white' }} variant="h5" fontWeight="bold" gutterBottom>
    Available Courses to Enroll
  </Typography>

  <TextField
    fullWidth
    variant="outlined"
    placeholder="Search courses..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon />
        </InputAdornment>
      ),
    }}
    sx={{
      mr: 2,
      
      backgroundColor: 'rgba(255,255,255,0.15)',
     
      '& .MuiOutlinedInput-root': {
        
       
        '& fieldset': {
          borderColor: 'rgba(255,255,255,0.4)',
        },
        '&:hover fieldset': {
          borderColor: '#ff6600',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#ff6600',
          boxShadow: '0 0 8px #ff6600',
        },
        '& input': {
          
          paddingLeft: '8px',
        },
      },
      '& .MuiInputAdornment-root svg': {
        color: '#ff6600',
      },
    }}
  />

  <List>
    {allCourses
      .filter(
        (c) =>
          !user.enrolledCourses.some((e) => e.id === c.id) &&
          (c.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            c.description.toLowerCase().includes(searchQuery.toLowerCase()))
      )
      .map((course) => (
        <ListItem key={course.id} disableGutters className="w3-animate-zoom">
          <Paper

            elevation={6}
            sx={{
              p: 3,
              width: '100%',
              mb: 2,
              borderRadius: 4,
              background: 'rgba(255, 255, 255, 0.85)',
              backdropFilter: 'blur(10px)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
            }}
          >
            <Button
              variant="outlined"
              startIcon={<AddCircleOutlineIcon />}
              sx={{
                height: 'fit-content',
                ':hover': { backgroundColor: '#e65c00' },
                mt: 1,
                mb: 1,
              }}
              
              onClick={(e) => {
                fireEmojiStars(e); // 🌟🎉✨
                enroll(course.id);
                
              }}
            >
              Enroll
            </Button>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <Chip
                  label={course.title}
                  sx={{
                    backgroundColor: '#ff6600',
                    color: 'white',
                    fontWeight: 'bold',
                    mb: 1,
                  }}
                />
                <Divider
                  sx={{
                    mb: 2,
                    borderBottomWidth: 2,
                    background: 'linear-gradient(to right, #1976d2, #42a5f5)',
                    borderRadius: 2,
                  }}
                />
                <Box display="flex" alignItems="center" gap={1} mt={2}>
                  <DescriptionIcon color="primary" />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Description
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {course.description}
                </Typography>

                <Box display="flex" alignItems="center" gap={1}>
                  <FlagIcon color="primary" />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Objectives
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {course.objectives}
                </Typography>

                <Box display="flex" alignItems="center" gap={1}>
                  <AccessTimeIcon color="primary" />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Duration
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {course.duration}
                </Typography>

                <Box display="flex" alignItems="center" gap={1}>
                  <VerifiedIcon color="primary" />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Certification
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary">
                  {course.certification}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </ListItem>
      ))}
  </List>
</>
          </>
        )}

        {user.role === 'instructor' && (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h5" fontWeight="bold" style={{ color: "white" }}>Courses You Teach</Typography>
              <Button
                variant="contained"
                color="success"
                startIcon={<AddCircleOutlineIcon />}
                onClick={() => navigate('/create-course')}
              >
                Create New Course
              </Button>
            </Box>

            {user.teachingCourses.length === 0 ? (
  <Typography color="white">You haven’t created any courses yet.</Typography>
              ) : (
                <List>
                  {user.teachingCourses.map(course => (
                    <ListItem
                      key={course.id}
                      disableGutters
                      secondaryAction={
                        <IconButton
                          edge="end"
                          aria-label="delete"
                          onClick={() => handleDeleteCourse(course.id)}
                          sx={{
                            color: 'error.main',
                            '&:hover': { backgroundColor: 'rgba(255, 0, 0, 0.1)' }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      }
                    >
                      <Paper
                        style={{ borderTop: "3px solid #ff6600" }}
                        elevation={6}
                        sx={{
                          p: 4,
                          borderRadius: 4,
                          background: 'rgba(255, 255, 255, 0.85)',
                          backdropFilter: 'blur(10px)',
                          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                          width: '100%',
                        }}
                      >
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                          {course.title}
                        </Typography>
                        <Divider
                          sx={{
                            mb: 2,
                            borderBottomWidth: 2,
                            background: 'linear-gradient(to right, #1976d2, #42a5f5)',
                            borderRadius: 2,
                          }}
                        />
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                          {course.description}
                        </Typography>
                        <Box mt={2} display="flex" gap={2}>
                          <Button
                            variant="outlined"
                            startIcon={<MenuBookIcon />}
                            onClick={() =>
                              navigate(`/courses/${course.id}/chapters`, { state: { user } })
                            }
                          >
                            View Chapters
                          </Button>

                          <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<PeopleIcon />}
                            onClick={() =>
                              navigate(`/courses/${course.id}/students`, { state: { course } })
                            }
                          >
                            View Enrolled Students
                          </Button>
                        </Box>
                      </Paper>
                    </ListItem>
                  ))}
                </List>
              )}

          </>
        )}
      </Container>
    </Box>
      
    </Box>
  );
}

export default DashboardPage;
